import { useBoolean } from 'aa_common/front-end/hooks'

export const useAIAssistantDrawer = (onTryAgain?: () => void) => {
  const [visible, setTrue, setFalse] = useBoolean(false)

  return {
    visible,
    openDrawer: setTrue,
    closeDrawer: () => {
      setFalse()
      onTryAgain?.()
    },
  }
}
